export function handleLogin (mode) {
  return { type: "HANDLE_LOGIN", payload: mode };
}
